export const ADMISSION_PRELUDE_ROUTE = "/workflow/prelude";
